import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    minHeight: 56,
    maxHeight: 56,
    padding: theme.spacing(0, 1.5),
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    gap: theme.spacing(1.5),
  },
  info: {
    flex: 1,
    minWidth: 0,
  },
}));

const TicketHeaderSkeleton = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Skeleton variant="circle" width={28} height={28} />
      <Skeleton variant="circle" width={36} height={36} />
      <div className={classes.info}>
        <Skeleton variant="text" width="55%" height={20} />
        <Skeleton variant="text" width="40%" height={14} />
      </div>
      <Skeleton variant="rect" width={120} height={28} style={{ borderRadius: 4 }} />
    </div>
  );
};

export default TicketHeaderSkeleton;
